@if ({
  loading: loading | async
  }; as vm) {
  @if (vm.loading) {
    <div
      flexLayout="row"
      flexLayoutAlign="center center"
      [class.overlay]="overlay === true"
      >
      <mat-spinner [diameter]="diameter"></mat-spinner>
    </div>
  }
}
